(()=>{
  let getSwiperLib = ()=>{
    return window.Swiper;
  };
  let waitObject = (callback, getter, flag, name)=>{
    if(!flag) {
      console.log("Try to locate `"+name+"`...");
    } else {
      console.log("Retry to locate `"+name+"`...");
    }
    let btn = getter();
    if(!btn) {
      if(window.tick_20250510180524) {
        clearTimeout(window.tick_20250415123026);
      }
      window.tick_20250510180524 = setTimeout(()=>{
        waitObject(callback, getter, true, name);
      }, 100);
    } else {
      console.log("Locate `"+name+"` successfully.");
      callback.call();
    }
  };
  let getMySwiper = () => {
    return document.querySelector(".announcement-bar .announcement-carousel-container .ac-swiper-container");
  };
  let loadSwiper = ()=>{
    let tout = document.querySelector(".switch_timeout").value;
    if(!tout) tout = 3000;
    else tout = parseInt(tout);
    var swiper = new Swiper(getMySwiper(), {
      navigation: {
        nextEl: ".announcement-bar .swiper-button-next",
        prevEl: ".announcement-bar .swiper-button-prev",
      },
      loop: true,
      autoplay: {
        delay: tout,
        disableOnInteraction: false,
      },
    });
    //console.log("annoucement loaded.");
  };
  document.addEventListener('DOMContentLoaded', ()=>{
	  waitObject(loadSwiper, getSwiperLib, false, "SwiperJS")
  });
})()